import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
// TODO(DEV-33650): swap to outdoor walking age assets once design delivers them (Figma New-Segments-Growth-2.0).
// Reusing the indoor walking imagery as a placeholder for now, same as age-walking-outdoor-f.
import walking40Webp from '@/assets/landing-age-selection/indoor-walking-40.webp'
import walking50Webp from '@/assets/landing-age-selection/indoor-walking-50.png'
import walking60Webp from '@/assets/landing-age-selection/indoor-walking-60.webp'
import walking70Webp from '@/assets/landing-age-selection/indoor-walking-70.webp'

// DEV-34970: age-walking-outdoor-f for the lymphatic UTM cohort (see landing.overrides in
// funnels/areas/walking/activity-female-walking-outdoor.ts). Only the title differs from the
// control; the copy is shared with main-walking, hence the main_walking.* key.
const schema: LandingScreenSchema = {
	order: ['LandingLanguageButton', 'LandingHead', 'LandingTitle', 'LandingSubtitle', 'LandingAgeGrid'],

	components: {
		LandingTitle: ({ $t }): LandingComponentsConfig['LandingTitle'] => ({
			title: $t('main_walking.lymphatic.age_picker.title'),
			size: 'large',
			uppercase: true,
		}),

		LandingSubtitle: ({ $t }): LandingComponentsConfig['LandingSubtitle'] => ({
			uppercase: true,
			title: $t('female_activity.pages.landing.step_1.subtitle', {
				age: `<b>${$t('female_activity.pages.landing.step_1.age')}</b>`,
			}),
		}),

		LandingAgeGrid: ({ $t }): LandingComponentsConfig['LandingAgeGrid'] => ({
			theme: 'purple',
			ageRanges: [
				{
					value: 40,
					analyticValue: '40-49',
					label: $t('female_yoga.pages.landing.age_range.40_49'),
					img: walking40Webp,
				},
				{
					value: 50,
					analyticValue: '50-59',
					label: $t('female_yoga.pages.landing.age_range.50_59'),
					img: walking50Webp,
				},
				{
					value: 60,
					analyticValue: '60-69',
					label: $t('female_yoga.pages.landing.age_range.60_69'),
					img: walking60Webp,
				},
				{
					value: 70,
					analyticValue: '70+',
					label: $t('female_yoga.pages.landing.age_range.70_80'),
					img: walking70Webp,
				},
			],
			otherAgesButton: {
				data: { value: 18, analyticValue: '18-39' },
				text: $t('female_yoga.pages.landing.im_young'),
			},
		}),
	},
}

export default schema
